const cms = (() =>{
    const initBlock = el => 
        el.querySelectorAll('a').forEach(a => 
            a.classList.add('text-link'));
    return {initBlock};
})();
ControlBinders.register(`.cms`, el => cms.initBlock(el));